import { IConfiguration } from "../../tools/configure";
export const options: IConfiguration = {};
